import React, { useEffect } from 'react';
import withView from '../../../cmn/docAutomation/withView';
import { UiView, UiViewContent } from '../../../../library/layout/Index';

const DocGridStatRow = (props)=>{
    const {formObject, viewData, rowKey, reloadSearch} = props

    // console.log("xystats", viewData);

    const renderView = () => {
        let DynamicComponent = formObject.viewMap[viewData.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vCMNGridLabel"];
        }

        if(!DynamicComponent)
        {

            return null;
        }
        else
        {
            return <DynamicComponent formObject={formObject} viewData={viewData} 
                rowKey={rowKey} reloadSearch={reloadSearch}/>
        }
    }

    return(
        <div>{renderView()}</div>
    )
}

const DocGridYStatData = (props)=>{
    const {formObject, viewData, reloadSearch, xGridSize, sidebarScroll, onSidebarScroll} = props

    // console.log("custom action set", formObject.dataList);
    const initialiseActions = () => {
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    useEffect(initialiseActions, [props.viewData]);
    
    if(viewData){
        return(
            <UiView>
                <UiViewContent>
                    <ul className="uiListContainer uiListScroll sidebar-scroll" style={{height:`${(xGridSize && xGridSize.height)}px`}} 
                        id="sidebar-scroll"
                        ref={sidebarScroll}
                        onScroll={onSidebarScroll}>
                        {
                            Object.values(viewData).map((row, index)=>(
                                <li key={index} className="uiListRow">
                                    <DocGridStatRow formObject={formObject} 
                                        viewData={row}
                                        rowKey={row.rowKey}
                                        reloadSearch={reloadSearch}></DocGridStatRow>
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        )
    }
    else return null;
}

export default withView(DocGridYStatData, '', '', 0);
